export default "__VITE_ASSET__UAzyOX4K__"